import React from 'react';
import styled from 'styled-components';
import Box from '@nubank/nuds-web/components/Box/Box';
import Typography from '@nubank/nuds-web/components/Typography/Typography';

import Image from '@nubank/www-latam-commons/components/Image/Image';

const Section = styled(Box)`
  background-color: #FFF;
  margin-top: 80px;
  margin-bottom: 60px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 100%;

  @media (width >= 768px) {
    margin-top: 120px;
    margin-bottom: 120px;
  }
`;

const Title = styled(Typography)`
  letter-spacing: -0.03em;
  text-align: center;
  background: linear-gradient(99.92deg, #9F2DEB 18.57%, #6200A3 71.77%);
  background-clip: text;
  /* stylelint-disable property-no-vendor-prefix, property-no-unknown */
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 36px;
  font-weight: 500;
  line-height: 40.32px;

  @media (width >= 768px) {
    margin-top: 20px;
    font-size: 48px;
    font-weight: 500;
    line-height: 55.68px;
  }
`;

const Subtitle = styled(Typography)`
  font-size: 24px;
  font-weight: 500;
  line-height: 31.68px;
  letter-spacing: -0.02em;
  text-align: center;

  @media (width >= 768px) {
    font-size: 40px;
    line-height: 48px;
    letter-spacing: -0.03em;
  }
`;

function Hero() {
  return (
    <Section tag="section">
      <Title
        variant="heading1"
        marginBottom={{ xs: '60px', lg: '80px' }}
        whiteSpace={{ xs: 'pre-line', md: 'initial' }}
      >
        {'Te damos atención\n'}
        <Box tag="span" display={{ xs: 'initial', md: 'none' }}>
          {' y soporte'}
        </Box>
        <span>
          {' 24/7'}
        </span>

      </Title>

      <Box
        marginHorizontal={{ xs: '24px', md: '60px', lg: '80px' }}
        marginBottom={{ xs: '40px', md: '60px', lg: '80px' }}
      >
        <Image
          srcSet={{
            xs: 'atencion/hero-xs.jpg',
            md: 'atencion/hero-lg.jpg',
          }}
          alt="Imgen de una persona sosteniendo un teléfono"
          maxWidth={{ xs: '100%', md: '1391px' }}
        />
      </Box>

      <Subtitle variant="heading3">
        Siempre estamos
        <Subtitle variant="heading3" tag="span" color="primary" strong whiteSpace={{ xs: 'pre-wrap', md: 'initial' }}>
          {' disponibles  \n'}
        </Subtitle>
        <Subtitle variant="heading3" tag="span" strong whiteSpace={{ xs: 'initial', md: 'pre-wrap' }}>
          {'para \n '}
        </Subtitle>
        <Subtitle variant="heading3" tag="span" strong whiteSpace={{ xs: 'pre-wrap', md: 'initial' }}>
          { 'ayudarte a resolver \n tus dudas'}
        </Subtitle>
      </Subtitle>

    </Section>
  );
}

export default Hero;
